/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import { LOADING_END, LOADING_START } from '../loading';
import * as apiManager from '../../Manager/services/api-endpoints';
import FileService from '../../services/FileService';
import { ExportActions } from '../../Enums';

/**
 * @param {string[]} profileIds
 * @param {ExportActions} exportAction
 */
export const downloadReportAsCsv = (profileIds, exportAction) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const [profileId] = profileIds;
        if (exportAction === ExportActions.ExportManager) {
            const response = await apiManager.DownloadManagerAuditReport(profileId);
            if (response.status === 200) {
                FileService.downloadContentInFile('ManagerAuditReport', 'csv', response.data);
            } else {
                toastr.error('Downloading manager audit report', 'Failed to download');
            }
        } else {
            const response = await apiManager.DownloadEmployeeAuditReport(profileId);
            if (response.status === 200) {
                FileService.downloadContentInFile('EmployeeAuditReport', 'csv', response.data);
            } else {
                toastr.error('Downloading employee audit report', 'Failed to download');
            }
        }
    } catch (error) {
        toastr.error('Downloading audit report', 'Failed to download');
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
